// extracted by mini-css-extract-plugin
export default {"toolBar":"PrintPage_toolBar__DSYi6"};